import { useEffect, useState } from "react";

import { type SIZE } from "@/configs/sizes";
import { iconMapZoomScaling, iconSizes } from "@/features/map-markers/device-marker/configs/sizes";
import GlobalOptions from "../../../../utils/global-options";

import { getMapBreakpoint } from "../../constants";

// Gets current icon scaling factor
export const getIconScaling = (zoom: number) => {
    const currentZoomBreakpoint = getMapBreakpoint(zoom);
    return iconMapZoomScaling[currentZoomBreakpoint];
};

// Gets the base size based on the user's icon size preference
export const getUserPreferredIconSize = () => iconSizes[GlobalOptions.userIconSizePreference as SIZE];

export interface IconSizeHookProps {
    mapComponent: L.Map;
}

// Hook to scale icons size based on map zoom
export const useIconSize = ({ mapComponent }: IconSizeHookProps) => {
    const [iconSizeScaling, setIconSizeScaling] = useState(getIconScaling(mapComponent.getZoom()));

    // Scale icons based on map zoom
    useEffect(() => {
        const debouncedZoom = () => {
            const scaling = getIconScaling(mapComponent.getZoom());
            setIconSizeScaling(scaling);
        };

        if (mapComponent) {
            // Update on map zoom
            mapComponent.on("zoomend", debouncedZoom);
        }
        return () => {
            if (mapComponent) {
                mapComponent.off("zoomend", debouncedZoom);
            }
        };
    }, [mapComponent]);

    return getUserPreferredIconSize() * iconSizeScaling;
};
